import React from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";
import Calculator from "./Calculator";
import Navbar from "./Navbar";
import { Swiper, SwiperSlide } from "swiper/react";
import play from "../assets/play.png";
import apple from "../assets/app.png";
import cios from "../assets/cios.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../Contexts/AuthContext";

const Hero = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  return (
    <div className="Hero_section mt-10 px-md-3 py-md-2">
      <Navbar />
      <div
        className="d-flex justify-content-between align-items-center 
      hero_main canvas"
      >
        <div className="w-50">
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: false,
            }}
            navigation={false}
            modules={[Autoplay]}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="pb-2">
                <h1 className="hero_h">
                  Tus Envíos a través de Criptomonedas.
                  Simple y Seguro.
                </h1>
                <div className="mt-md-3 mt-2">
                  <p>
                    Tú decides cómo recibir tu dinero, en Criptomonedas o Bolívares en Cuentas Bancarias de cualquier Banco de Venezuela.
                  </p>

                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
              <div className="pb-2">
                <h1 className="hero_h">
                  Envía a Venezuela en Bolívares o a wallets USDT.
                </h1>
                <div className="mt-md-3 mt-2">
                  <p>
                    Servicio disponible para toda la Unión Europea. Más de 9 años brindando soluciones a nuestros clientes.
                  </p>
                </div>
              </div>
            </SwiperSlide> */}
          </Swiper>
          <div className="d-flex gap-3 mt-md-3 mt-2 items-center">
            <button
              className="px-3 btn  special_btn rounded-pill"
              style={{ border: "1.99px solid black" }}
              onClick={() => navigate("/registro")}
            >
              Abrir Cuenta
            </button>
            <div className="d-flex">
              <Link to={"https://play.google.com/store/apps/details?id=com.transferven.app"} target="_blank">
                <img src={play} width={145} />
              </Link>
            </div>
          </div>
        </div>
        <Calculator btn={true} />
      </div>
    </div>
  );
};

export default Hero;
